var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
const LANGUAGES = { en: "http://vocab.getty.edu/aat/300388277", fr: "http://vocab.getty.edu/aat/300388306", de: "http://vocab.getty.edu/aat/300388344", es: "http://vocab.getty.edu/aat/300389311", zh: "http://vocab.getty.edu/aat/300388113", hi: "http://vocab.getty.edu/aat/300388412", af: "http://vocab.getty.edu/aat/300387782", sq: "http://vocab.getty.edu/aat/300387803", ar: "http://vocab.getty.edu/aat/300387843", bg: "http://vocab.getty.edu/aat/300388034", bs: "http://vocab.getty.edu/aat/300388023", ca: "http://vocab.getty.edu/aat/300388072", pt: "http://vocab.getty.edu/aat/300389115", bn: "http://vocab.getty.edu/aat/300387971", ru: "http://vocab.getty.edu/aat/300389168", nl: "http://vocab.getty.edu/aat/300388256", fi: "http://vocab.getty.edu/aat/300388299", is: "http://vocab.getty.edu/aat/300388449", ga: "http://vocab.getty.edu/aat/300388467", it: "http://vocab.getty.edu/aat/300388474", fa: "http://vocab.getty.edu/aat/300388296", gu: "http://vocab.getty.edu/aat/300388371", ko: "http://vocab.getty.edu/aat/300388633", la: "http://vocab.getty.edu/aat/300388693", lt: "http://vocab.getty.edu/aat/300388723", mk: "http://vocab.getty.edu/aat/300388760", ja: "http://vocab.getty.edu/aat/300388486", hr: "http://vocab.getty.edu/aat/300388185", cs: "http://vocab.getty.edu/aat/300388191", da: "http://vocab.getty.edu/aat/300388204", el: "http://vocab.getty.edu/aat/300388361", ka: "http://vocab.getty.edu/aat/300388343", he: "http://vocab.getty.edu/aat/300388401", hu: "http://vocab.getty.edu/aat/300388770", no: "http://vocab.getty.edu/aat/300388992", pl: "http://vocab.getty.edu/aat/300389109", ro: "http://vocab.getty.edu/aat/300389157", sk: "http://vocab.getty.edu/aat/300389290", sl: "http://vocab.getty.edu/aat/300389291", sr: "http://vocab.getty.edu/aat/300389247", sv: "http://vocab.getty.edu/aat/300389336", tr: "http://vocab.getty.edu/aat/300389470", cy: "http://vocab.getty.edu/aat/300389555" }, ACCESSION_NUMBERS = "http://vocab.getty.edu/aat/300312355", ACKNOWLEDGEMENT = "http://vocab.getty.edu/aat/300026687", COPYRIGHT = "http://vocab.getty.edu/aat/300435434", CULTURE = "http://vocab.getty.edu/aat/300055768", DIGITAL_IMAGES = "http://vocab.getty.edu/aat/300215302", DIMENSIONS_DESCRIPTION = "http://vocab.getty.edu/aat/300435430", LEGAL_CONCEPTS = "http://vocab.getty.edu/aat/300055547", MATERIALS_DESCRIPTION = "http://vocab.getty.edu/aat/300435429", PREFERRED_TERM = "http://vocab.getty.edu/aat/300404670", RIGHTS = "http://vocab.getty.edu/aat/300417696", WORK_TYPE = "http://vocab.getty.edu/aat/300435443", CLASSIFICATION = "http://vocab.getty.edu/aat/300435444", aat = {
  LANGUAGES,
  ACCESSION_NUMBERS,
  ACKNOWLEDGEMENT,
  COPYRIGHT,
  CULTURE,
  DIGITAL_IMAGES,
  DIMENSIONS_DESCRIPTION,
  LEGAL_CONCEPTS,
  MATERIALS_DESCRIPTION,
  PREFERRED_TERM,
  RIGHTS,
  WORK_TYPE,
  CLASSIFICATION
}, AND = "AND", ASSIGNED = "assigned", ASSIGNED_BY = "assigned_by", ASSIGNED_PROPERTY = "assigned_property", ATTRIBUTED_BY = "attributed_by", CARRIED_OUT_BY = "carried_out_by", CLASSIFIED_AS = "classified_as", CLASSIFIED_BY = "classified_by", IDENTIFIED_BY = "identified_by", NAME = "Name", OR = "OR", PART = "part", PRODUCED_BY = "produced_by", REFERRED_TO_BY = "referred_to_by", REPRESENTATION = "representation", SUBJECT_TO = "subject_to", TIMESPAN = "timespan", UNKNOWN = "Unknown";
function normalizeFieldToArray(obj, key) {
  if (obj == null)
    return [];
  var val = obj[key];
  return val == null ? [] : Array.isArray(val) == !1 ? [val] : val.length < 1 ? [] : val;
}
__name(normalizeFieldToArray, "normalizeFieldToArray");
function normalizeAatId(id) {
  let id_ = id.toLowerCase();
  return id_.startsWith("aat:") ? id_.replace("aat:", "http://vocab.getty.edu/aat/") : id_.startsWith("https://vocab.getty.edu/aat/") ? id_.replace(
    "https://vocab.getty.edu/aat/",
    "http://vocab.getty.edu/aat/"
  ) : id_.replace("http://vocab.getty.edu/aat/", "aat:");
}
__name(normalizeAatId, "normalizeAatId");
function normalizeFieldWithParts(object, field) {
  let part = object[field];
  if (part == null)
    return [];
  let parts = [];
  return Array.isArray(part[PART]) == !1 ? Array.isArray(part) ? parts = part : parts = [part] : (parts = [...part[PART]], _hasUniqueFields(part, ["id", "_label", "label", "type", PART]) && parts.push(part)), parts;
}
__name(normalizeFieldWithParts, "normalizeFieldWithParts");
function _hasUniqueFields(object, fieldsToIgnore = ["id", "_label", "label", "type"]) {
  let keys = Object.keys(object);
  return keys.filter((key) => fieldsToIgnore.indexOf(key) == !1), keys.length > 0;
}
__name(_hasUniqueFields, "_hasUniqueFields");
const NO_LANGUAGE = "NO_LANGUAGE";
function doesObjectLanguageMatch(object, language, languageOptions = {}) {
  if (language == null)
    return !0;
  let lang_ids = getLanguageId(object, languageOptions);
  return lang_ids.includes(normalizeLanguageId(language, languageOptions)) || languageOptions.fallbackLanguage != null && lang_ids.includes(
    normalizeLanguageId(languageOptions.fallbackLanguage, languageOptions)
  ) ? !0 : lang_ids.includes(NO_LANGUAGE) || lang_ids.length == 0 ? languageOptions.includeItemsWithNoLanguage != !1 : !1;
}
__name(doesObjectLanguageMatch, "doesObjectLanguageMatch");
function getLanguageId(obj, languageOptions) {
  if (obj == null || obj.language == null)
    return [NO_LANGUAGE];
  if (typeof obj.language == "string")
    return [normalizeLanguageId(obj.language, languageOptions)];
  let toReturn = /* @__PURE__ */ new Set();
  return obj.language.forEach((lang) => {
    lang == null ? toReturn.add(NO_LANGUAGE) : typeof lang == "string" ? toReturn.add(lang) : lang.id && toReturn.add(lang.id);
  }), toReturn = Array.from(toReturn).map(
    (item) => normalizeLanguageId(item, languageOptions)
  ), toReturn;
}
__name(getLanguageId, "getLanguageId");
function normalizeLanguageId(lang_id, languageOptions) {
  if (lang_id == null)
    return NO_LANGUAGE;
  let lookupMap = aat.LANGUAGES;
  languageOptions && languageOptions.lookupMap && (lookupMap = languageOptions.lookupMap);
  let lang = lang_id.toLowerCase();
  lang.match(/\/[a-zA-Z]+$/) && (lang = lang.substring(lang.lastIndexOf("/") + 1));
  let lookup = lookupMap[lang];
  return lookup ?? lang_id;
}
__name(normalizeLanguageId, "normalizeLanguageId");
function lookupIsoFromAat(id = "") {
  let iso, normalizedAat = id;
  return (id.startsWith("aat:") || id.startsWith("https")) && (normalizedAat = normalizeAatId(id)), Object.keys(aat.LANGUAGES).forEach((key) => {
    aat.LANGUAGES[key] == normalizedAat && (iso = key);
  }), iso;
}
__name(lookupIsoFromAat, "lookupIsoFromAat");
function lookupAatFromIso(iso) {
  return aat.LANGUAGES[iso];
}
__name(lookupAatFromIso, "lookupAatFromIso");
function getClassifiedAs(submittedResource, requestedClassifications, { language = void 0, languageOptions = {}, operator } = {}) {
  return getClassified(submittedResource, requestedClassifications, {
    classificationField: CLASSIFIED_AS,
    language,
    languageOptions,
    operator
  });
}
__name(getClassifiedAs, "getClassifiedAs");
function getClassifiedBy(submittedResource, requestedClassifications, { language = void 0, languageOptions = {}, operator } = {}) {
  return getClassified(submittedResource, requestedClassifications, {
    classificationField: CLASSIFIED_BY,
    language,
    languageOptions,
    operator
  });
}
__name(getClassifiedBy, "getClassifiedBy");
function getClassifiedAsWithClassification(submittedResource, nestedClassification, { language = void 0, languageOptions = {}, operator } = {}) {
  return _getClassificationsWithNestedClass(
    submittedResource,
    nestedClassification,
    CLASSIFIED_AS,
    { language, languageOptions, operator }
  );
}
__name(getClassifiedAsWithClassification, "getClassifiedAsWithClassification");
function getClassifiedByWithClassification(submittedResource, nestedClassification, { language = void 0, languageOptions = {}, operator } = {}) {
  return _getClassificationsWithNestedClass(
    submittedResource,
    nestedClassification,
    CLASSIFIED_BY,
    { language, languageOptions, operator }
  );
}
__name(getClassifiedByWithClassification, "getClassifiedByWithClassification");
function getObjectsClassifiedAsWithClassification(submittedResource, nestedClassification, { language = void 0, languageOptions = {}, operator } = {}) {
  return _getObjectWithNestedClass(
    submittedResource,
    nestedClassification,
    CLASSIFIED_AS,
    { language, languageOptions, operator }
  );
}
__name(getObjectsClassifiedAsWithClassification, "getObjectsClassifiedAsWithClassification");
function getObjectsClassifiedByWithClassification(submittedResource, nestedClassification, { language = void 0, languageOptions = {} } = {}) {
  return _getObjectWithNestedClass(
    submittedResource,
    nestedClassification,
    CLASSIFIED_BY,
    { language, languageOptions }
  );
}
__name(getObjectsClassifiedByWithClassification, "getObjectsClassifiedByWithClassification");
function getPrimaryName(submittedResource, {
  requestedClassifications = aat.PREFERRED_TERM,
  language,
  languageOptions = {}
} = {}) {
  return getPrimaryNames(submittedResource, {
    requestedClassifications,
    language,
    languageOptions
  })[0];
}
__name(getPrimaryName, "getPrimaryName");
function getPrimaryNames(submittedResource, {
  requestedClassifications = aat.PREFERRED_TERM,
  language,
  languageOptions = {}
} = {}) {
  if (submittedResource == null)
    return UNKNOWN;
  let names = normalizeFieldToArray(submittedResource, IDENTIFIED_BY).filter((item) => item.type == NAME), name = getValuesByClassification(names, requestedClassifications, {
    language,
    languageOptions
  });
  if (name.length > 0)
    return name;
  if (names.length > 0 && requestedClassifications == aat.PREFERRED_TERM) {
    let values = [...names];
    for (let i in values)
      values[i] = getValueOrContent(values[i]);
    return values;
  }
  let label = UNKNOWN;
  return submittedResource && submittedResource.id && (label += " (" + submittedResource.id + ")"), [label];
}
__name(getPrimaryNames, "getPrimaryNames");
function getClassified(submittedResource, requestedClassifications, {
  classificationField = CLASSIFIED_AS,
  language = void 0,
  languageOptions = {},
  operator = AND
} = {}) {
  let results = [], resourceArray = _convertToArrayIfNeeded(submittedResource), requestedClassArray = _convertToArrayIfNeeded(requestedClassifications);
  if (resourceArray.length == 0 || requestedClassArray.length == 0)
    return results;
  for (const resource of resourceArray) {
    var classified_as = normalizeFieldToArray(resource, classificationField);
    let languageMatch = doesObjectLanguageMatch(
      resource,
      language,
      languageOptions
    );
    if (!classified_as.length)
      continue;
    let classificationIDs = classified_as.map(
      (obj) => typeof obj == "string" ? obj : obj.id
    ), inClassificationIDs = /* @__PURE__ */ __name((id) => languageMatch && classificationIDs.includes(id) || classificationIDs.includes(normalizeAatId(id)), "inClassificationIDs");
    if (operator.toUpperCase() == AND)
      requestedClassArray.every(inClassificationIDs) && results.push(resource);
    else if (operator.toUpperCase() == OR)
      requestedClassArray.some(inClassificationIDs) && results.push(resource);
    else
      throw `unknown operator specified: ${operator}, please use and/or`;
  }
  return results;
}
__name(getClassified, "getClassified");
function getValueByClassification(submittedResource, requestedClassifications, { language, languageOptions, operator } = {}) {
  let results = getClassifiedAs(submittedResource, requestedClassifications, {
    language,
    languageOptions,
    operator
  });
  if (results.length)
    return getValueOrContent(results[0]);
}
__name(getValueByClassification, "getValueByClassification");
function getValuesByClassification(submittedResource, requestedClassifications, { language, languageOptions, operator } = {}) {
  let results = getClassifiedAs(submittedResource, requestedClassifications, {
    language,
    languageOptions,
    operator
  });
  if (results.length) {
    let values = [];
    return results.forEach((result) => {
      const value = getValueOrContent(result);
      value && values.push(value);
    }), values;
  }
  return [];
}
__name(getValuesByClassification, "getValuesByClassification");
function getValueOrContent(object) {
  if (object != null) {
    if (object.value !== void 0)
      return object.value;
    if (object.content)
      return object.content;
  }
}
__name(getValueOrContent, "getValueOrContent");
function getReferredToByClassification(object, classification) {
  if (!object) return;
  const referredToBy = object[REFERRED_TO_BY];
  if (referredToBy)
    return getValueByClassification(referredToBy, classification);
}
__name(getReferredToByClassification, "getReferredToByClassification");
function getAttributedBy(object, assignedProperty) {
  let attributed = normalizeFieldToArray(object, ATTRIBUTED_BY);
  return attributed.length == 0 ? [] : _getAssignedProperty(attributed, assignedProperty);
}
__name(getAttributedBy, "getAttributedBy");
function getAssignedBy(object, assignedProperty) {
  let assigned = normalizeFieldToArray(object, ASSIGNED_BY);
  return assigned.length == 0 ? [] : _getAssignedProperty(assigned, assignedProperty);
}
__name(getAssignedBy, "getAssignedBy");
function getObjectParts(object, field) {
  const fieldRequested = object[field];
  if (!fieldRequested)
    return [];
  let fieldPart = normalizeFieldToArray(fieldRequested, PART);
  return fieldPart.length == 0 ? [fieldRequested] : fieldPart;
}
__name(getObjectParts, "getObjectParts");
function _convertToArrayIfNeeded(resourceParam) {
  let results = [], resourceArray = resourceParam;
  return resourceParam == null ? results : (Array.isArray(resourceParam) == !1 && (resourceArray = [resourceParam]), resourceArray);
}
__name(_convertToArrayIfNeeded, "_convertToArrayIfNeeded");
function _getAssignedProperty(assigned, assignedProperty) {
  let accumulator = [];
  return assigned.forEach((attr) => {
    (attr[ASSIGNED_PROPERTY] == assignedProperty || assignedProperty == null) && (Array.isArray(attr[ASSIGNED]) ? accumulator = accumulator.concat(attr[ASSIGNED]) : accumulator.push(attr[ASSIGNED]));
  }), accumulator;
}
__name(_getAssignedProperty, "_getAssignedProperty");
function _getObjectWithNestedClass(submittedResource, nestedClassification, classificationField = CLASSIFIED_AS, { language = void 0, languageOptions = {}, operator } = {}) {
  let { objects } = _getObjectsAndClassificationsWithNestedClass(
    submittedResource,
    nestedClassification,
    classificationField,
    { language, languageOptions, operator }
  );
  return objects;
}
__name(_getObjectWithNestedClass, "_getObjectWithNestedClass");
function _getClassificationsWithNestedClass(submittedResource, nestedClassifications, classificationField = CLASSIFIED_AS, { language = void 0, languageOptions = {}, operator } = {}) {
  let { classifications } = _getObjectsAndClassificationsWithNestedClass(
    submittedResource,
    nestedClassifications,
    classificationField,
    { language, languageOptions, operator }
  );
  return classifications;
}
__name(_getClassificationsWithNestedClass, "_getClassificationsWithNestedClass");
function _getObjectsAndClassificationsWithNestedClass(submittedResource, nestedClassifications, classificationField = CLASSIFIED_AS, { language = void 0, languageOptions = {}, operator }) {
  let returnObject = { classifications: [], objects: [] }, resourceArray = _convertToArrayIfNeeded(submittedResource);
  if (resourceArray.length == 0)
    return returnObject;
  for (const resource of resourceArray) {
    var classified_as = normalizeFieldToArray(resource, classificationField);
    if (!classified_as.length)
      continue;
    let classifications = getClassified(classified_as, nestedClassifications, {
      classificationField,
      language,
      languageOptions,
      operator
    });
    returnObject.classifications = returnObject.classifications.concat(classifications), classifications.length > 0 && returnObject.objects.push(resource);
  }
  return returnObject;
}
__name(_getObjectsAndClassificationsWithNestedClass, "_getObjectsAndClassificationsWithNestedClass");
function getFieldPartSubfield(object, field, subfield) {
  let parts = normalizeFieldWithParts(object, field), accumulator = [];
  return parts.forEach((part) => {
    let target = normalizeFieldToArray(part, subfield);
    accumulator = accumulator.concat(target);
  }), accumulator;
}
__name(getFieldPartSubfield, "getFieldPartSubfield");
function getFieldValuesByClassifications(submittedResource, field, requestedClassifications, { language, languageOptions, operator } = {}) {
  return getValuesByClassification(
    normalizeFieldToArray(submittedResource, field),
    requestedClassifications,
    { language, languageOptions, operator }
  );
}
__name(getFieldValuesByClassifications, "getFieldValuesByClassifications");
function getDimensionsDescriptions(submittedResource, {
  requestedClassifications = aat.DIMENSIONS_DESCRIPTION,
  language,
  languageOptions = {}
} = {}) {
  return getFieldValuesByClassifications(
    submittedResource,
    REFERRED_TO_BY,
    requestedClassifications,
    { language, languageOptions }
  );
}
__name(getDimensionsDescriptions, "getDimensionsDescriptions");
function getAccessionNumbers(submittedResource, {
  requestedClassifications = aat.ACCESSION_NUMBERS,
  language,
  languageOptions = {}
} = {}) {
  return getFieldValuesByClassifications(
    submittedResource,
    IDENTIFIED_BY,
    requestedClassifications,
    { language, languageOptions }
  );
}
__name(getAccessionNumbers, "getAccessionNumbers");
function getCarriedOutBy(object, field = PRODUCED_BY) {
  return getFieldPartSubfield(object, field, CARRIED_OUT_BY);
}
__name(getCarriedOutBy, "getCarriedOutBy");
function getCultures(submittedResource, {
  requestedClassifications = aat.CULTURE,
  language,
  languageOptions = {}
} = {}) {
  return getFieldValuesByClassifications(
    submittedResource,
    REFERRED_TO_BY,
    requestedClassifications,
    { language, languageOptions }
  );
}
__name(getCultures, "getCultures");
function getDigitalImages(submittedResource, { requestedClassifications = aat.DIGITAL_IMAGES } = {}) {
  const representations = normalizeFieldToArray(
    submittedResource,
    REPRESENTATION
  );
  return getClassifiedAs(
    representations,
    requestedClassifications
  ).map((img) => img.id);
}
__name(getDigitalImages, "getDigitalImages");
function getRightsStatements(submittedResource, {
  requestedClassifications = [aat.LEGAL_CONCEPTS, aat.RIGHTS],
  language,
  languageOptions = {}
} = {}) {
  const referredToBy = normalizeFieldToArray(submittedResource, REFERRED_TO_BY);
  return getClassified(referredToBy, requestedClassifications, {
    classificationField: CLASSIFIED_AS,
    language,
    languageOptions,
    operator: OR
  }).map((right) => getValueOrContent(right));
}
__name(getRightsStatements, "getRightsStatements");
function getCopyrightStatements(submittedResource, {
  requestedClassifications = aat.COPYRIGHT,
  language,
  languageOptions = {}
} = {}) {
  return getFieldValuesByClassifications(
    submittedResource,
    REFERRED_TO_BY,
    requestedClassifications,
    { language, languageOptions }
  );
}
__name(getCopyrightStatements, "getCopyrightStatements");
function getRightsAssertions(submittedResource) {
  const subjectTo = normalizeFieldToArray(submittedResource, SUBJECT_TO);
  let rightsAssertions = [];
  return subjectTo.forEach((obj) => {
    rightsAssertions = rightsAssertions.concat(obj[CLASSIFIED_AS]);
  }), rightsAssertions.map((d) => d.id);
}
__name(getRightsAssertions, "getRightsAssertions");
function getAcknowledgementStatements(submittedResource, {
  requestedClassifications = aat.ACKNOWLEDGEMENT,
  language,
  languageOptions = {}
} = {}) {
  return getFieldValuesByClassifications(
    submittedResource,
    REFERRED_TO_BY,
    requestedClassifications,
    { language, languageOptions }
  );
}
__name(getAcknowledgementStatements, "getAcknowledgementStatements");
function getMaterialStatements(submittedResource, {
  requestedClassifications = aat.MATERIALS_DESCRIPTION,
  language,
  languageOptions = {}
} = {}) {
  return getFieldValuesByClassifications(
    submittedResource,
    REFERRED_TO_BY,
    requestedClassifications,
    { language, languageOptions }
  );
}
__name(getMaterialStatements, "getMaterialStatements");
function getProductionTimespans(object) {
  return getFieldPartSubfield(object, PRODUCED_BY, TIMESPAN);
}
__name(getProductionTimespans, "getProductionTimespans");
function getWorkTypes(submittedResource, {
  requestedClassifications = aat.WORK_TYPE,
  language,
  languageOptions = {}
} = {}) {
  return getClassifiedAsWithClassification(
    submittedResource,
    requestedClassifications,
    { language, languageOptions }
  );
}
__name(getWorkTypes, "getWorkTypes");
function getClassifications(submittedResource, {
  requestedClassifications = aat.CLASSIFICATION,
  language,
  languageOptions = {}
} = {}) {
  return getClassifiedAsWithClassification(
    submittedResource,
    requestedClassifications,
    { language, languageOptions }
  );
}
__name(getClassifications, "getClassifications");
export {
  doesObjectLanguageMatch,
  getAccessionNumbers,
  getAcknowledgementStatements,
  getAssignedBy,
  getAttributedBy,
  getCarriedOutBy,
  getClassifications,
  getClassified,
  getClassifiedAs,
  getClassifiedAsWithClassification,
  getClassifiedBy,
  getClassifiedByWithClassification,
  getCopyrightStatements,
  getCultures,
  getDigitalImages,
  getDimensionsDescriptions,
  getFieldPartSubfield,
  getFieldValuesByClassifications,
  getLanguageId,
  getMaterialStatements,
  getObjectParts,
  getObjectsClassifiedAsWithClassification,
  getObjectsClassifiedByWithClassification,
  getPrimaryName,
  getPrimaryNames,
  getProductionTimespans,
  getReferredToByClassification,
  getRightsAssertions,
  getRightsStatements,
  getValueByClassification,
  getValueOrContent,
  getValuesByClassification,
  getWorkTypes,
  lookupAatFromIso,
  lookupIsoFromAat,
  normalizeAatId,
  normalizeFieldToArray,
  normalizeFieldWithParts,
  normalizeLanguageId
};
